export enum SearchCountryField {
	DialCode = 'dialCode',
	Iso2 = 'iso2',
	Name = 'name',
	All = 'all'
}
